export const l1PosList = [
    {
        x: 1000,
        y: -555,
        z: -460,
        content: "青农创业孵化中心",
    },
    {
        x: 1000,
        y: -853,
        z: -604,
        content: "大美大邑",
        label: "l2",
    },
    {
        x: 1000,
        y: -672,
        z: -379,
        content: "游客中心",
        label: "l3",
    },
    {
        x: 833,
        y: -582,
        z: -1000,
        content: '膳食研究所',
        label: "l4",
    },
    {
        x: 212,
        y: -377,
        z: -1000,
        content: '乐农学院',
        label: "l5",
    },
    {
        x: 357,
        y: -898,
        z: -1000,
        content: '稻乡渔歌艺术中心',
        label: 'l6'
    },
    {
        x: 143,
        y: -673,
        z: 1000,
        content: '朗星家庭农场',
        label: 'l7'
    },
    {
        x: -754,
        y: -760,
        z: 1000,
        content: '稻鸭渔立体综合综合区',
        label: 'l8'
    },
    {
        x: -1000,
        y: -338,
        z: 186,
        content: '仓储加工中心',
        label: 'l9'
    },
    {
        x: -1000,
        y: -209,
        z: 56,
        content: '大地之眼',
        label: 'l10'
    },
    {
        x: -1000,
        y: -200,
        z: 194,
        content: '美好村',
        label: 'l11'
    },
    {
        x: -1000,
        y: -462,
        z: 58,
        content: '玻璃温室'
    },
];

export const l2PosList = [
    {
        x: -653,
        y: -1000,
        z: -21,
        content: "游客中心",
        label: "l3",
    },
    {
        x: -1000,
        y: -140,
        z: 603,
        content: '稻鸭渔立体综合综合区',
        label: 'l8'
    },
    {
        x: -1000,
        y: -53,
        z: 86,
        content: '大地之眼',
        label: 'l10'
    },
    {
        x: -569,
        y: -135,
        z: -1000,
        content: '乐农学院',
        label: "l5",
    },
    {
        x: -260,
        y: -382,
        z: -1000,
        content: '膳食研究所',
        label: "l4",
    },
]

export const l3PosList = [
    {
        x: 1000,
        y: -307,
        z: 232,
        content: "青农创业孵化中心",
    },
    {
        x: 143,
        y: -358,
        z: 1000,
        content: "游客中心",
    },
    {
        x: -336,
        y: -23,
        z: -1000,
        content: '乐农学院',
        label: "l5",
    },
    {
        x: 110,
        y: -117,
        z: -1000,
        content: '膳食研究所',
        label: "l4",
    },
    {
        x: -1000,
        y: -80,
        z: -382,
        content: '稻乡渔歌艺术中心',
        label: 'l6'
    },
]

export const l4PosList = [
    {
        x: 1000,
        y: -576,
        z: -54,
        content: '膳食研究所',
    },
    {
        x: -287,
        y: -100,
        z: 1000,
        content: "游客中心",
        label: "l3",
    },
    {
        x: -1000,
        y: -60,
        z: -196,
        content: '稻乡渔歌艺术中心',
        label: 'l6'
    },
    {
        x: 86,
        y: -58,
        z: -1000,
        content: '乐农学院',
        label: "l5",
    },
]

export const l5PosList = [
    {
        x: 615,
        y: -250,
        z: 1000,
        content: '膳食研究所',
        label: "l4",
    },
    {
        x: 248,
        y: -56,
        z: 1000,
        content: "游客中心",
        label: "l3",
    },
    {
        x: -776,
        y: -63,
        z: 1000,
        content: '稻乡渔歌艺术中心',
        label: 'l6'
    },
    {
        x: -1000,
        y: -212,
        z: -914,
        content: '乐农学院',
    },
]

export const l6PosList = [
    {
        x: 1000,
        y: -116,
        z: -332,
        content: '膳食研究所',
        label: "l4",
    },
    {
        x: 933,
        y: -185,
        z: 1000,
        content: "游客中心",
        label: "l3",
    },
    {
        x: -1000,
        y: -259,
        z: -593,
        content: '稻乡渔歌艺术中心',
    },
    {
        x: 456,
        y: -76,
        z: -1000,
        content: '乐农学院',
        label: 'l5'
    },
    {
        x: -1000,
        y: -32,
        z: 993,
        content: '稻鸭渔立体综合综合区',
        label: 'l8'
    },
]

export const l7PosList = [
    {
        x: -1000,
        y: -94,
        z: 370,
        content: '稻鸭渔立体综合综合区',
        label: 'l8'
    },
    {
        x: -1000,
        y: -16,
        z: -167,
        content: '大地之眼',
        label: 'l10'
    },
    {
        x: 940,
        y: -36,
        z: -1000,
        content: "游客中心",
        label: "l3",
    },
    {
        x: 597,
        y: -259,
        z: 1000,
        content: '朗星家庭农场',
    },
]

export const l8PosList = [
    {
        x: 1000,
        y: -95,
        z: 103,
        content: '朗星家庭农场',
        label: 'l7'
    },
    {
        x: -1000,
        y: 7,
        z: -305,
        content: '大地之眼',
        label: 'l10'
    },
    {
        x: -257,
        y: -69,
        z: -1000,
        content: '玻璃温室'
    },
]

export const l9PosList = [
    {
        x: -1000,
        y: -31,
        z: -414,
        content: '大地之眼',
        label: 'l10'
    },
    {
        x: -1000,
        y: -31,
        z: -195,
        content: '美好村',
        label: 'l11'
    },
    {
        x: 1000,
        y: -75,
        z: 483,
        content: '稻鸭渔立体综合综合区',
        label: 'l8'
    },
]

export const l10PosList = [
    {
        x: 463,
        y: -221,
        z: 1000,
        content: '美好村',
        label: 'l11'
    },
]

export const l11PosList = [
    {
        x: 1000,
        y: -472,
        z: 775,
        content: '大地之眼',
        label: 'l10'
    },
]

// sq 墒情 ，bz 孢子 ，cq  虫情 ,qx 气象 ，sz 水质
export const l1DeviceList = [
    // 一号点位
    {
        id: '79739C3621456A2F',
        label: 'bz',
        x: 1000,
        y: -879,
        z: -896,
    },
    {
        id: '56AAAE16E4F0D389',
        label: 'cq',
        x: 1000,
        y: -831,
        z: -814,
    },
    {
        id: '37FFD5055642393729702451',
        label: 'qx',
        x: 1000,
        y: -784,
        z: -733,
    },
    {
        id: '26004100090000483136544E',
        label: 'cq',
        x: 1000,
        y: -736,
        z: -648,
    },
    {
        id: '867124065396038',
        label: 'sq',
        x: 1000,
        y: -697,
        z: -576,
    },
    // 二号点位
    {
        id: '38FFD7055248303238701651',
        label: 'qx',
        x: 729,
        y: -1000,
        z: 826,
    },
    {
        id: '69EE88582FDBB041',
        label: 'bz',
        x: 806,
        y: -1000,
        z: 928,
    },
    {
        id: 'BF9B467D8C488C01',
        label: 'cq',
        x: 845,
        y: -973,
        z: 1000,
    },
    {
        id: '867124065408619',
        label: 'sq',
        x: 824,
        y: -891,
        z: 1000,
    },
    {
        id: '26001500090000483136544E',
        label: 'cq',
        x: 803,
        y: -811,
        z: 1000,
    },
    // 3号线
    {
        id: '1574556931774488578',
        label: 'cq',
        x: -1000,
        y: -214,
        z: -2,
    },
    {
        id: '1681834436952068097',
        label: 'bz',
        x: -1000,
        y: -219,
        z: -35,
    },
    {
        id: '33004300050000483136544E',
        label: 'cq',
        x: -1000,
        y: -224,
        z: -54,
    },
    {
        id: '867124065381782',
        label: 'sq',
        x: -1000,
        y: -243,
        z: -71,
    },
    // 4号线
    {
        id: '27004100180000384753524E',
        label: 'qx',
        x: 567,
        y: -645,
        z: -1000,
    },
    {
        id: '28001000090000483136544E',
        label: 'cq',
        x: 605,
        y: -661,
        z: -1000,
    },
    {
        id: '867124065481608',
        label: 'sq',
        x: 654,
        y: -673,
        z: -1000,
    },
    {
        id: '1574556931816431619',
        label: 'cq',
        x: 680,
        y: -703,
        z: -1000,
    },
    {
        id: '1681834436952068101',
        label: 'bz',
        x: 734,
        y: -730,
        z: -1000,
    },
    // 5号线
    {
        id: '1574556931816431625',
        label: 'cq',
        x: 1000,
        y: -289,
        z: 493,
    },
    {
        id: '867124065409666',
        label: 'sq',
        x: 1000,
        y: -284,
        z: 532,
    },
    {
        id: '1681834436952068099',
        label: 'bz',
        x: 1000,
        y: -287,
        z: 577,
    },
    {
        id: '24004500090000483136544E',
        label: 'cq',
        x: 1000,
        y: -279,
        z: 630,
    },
    {
        id: '38FFD3055248343439662051',
        label: 'qx',
        x: 1000,
        y: -268,
        z: 660,
    },
    // 6号线
    {
        id: '867124065391286',
        label: 'sq',
        x: -1000,
        y: -316,
        z: 646,
    },
    {
        id: '1574556931816431617',
        label: 'cq',
        x: -1000,
        y: -297,
        z: 613,
    },
    {
        id: '1681834436952068102',
        label: 'bz',
        x: -1000,
        y: -268,
        z: 640,
    },
    // 7号线
    {
        id: '1681834436952068100',
        label: 'bz',
        x: -1000,
        y: -130,
        z: 287,
    },
    {
        id: '867124065395535',
        label: 'sq',
        x: -1000,
        y: -130,
        z: 258,
    },
    // 8号线
    {
        id: '867124065408536',
        label: 'sq',
        x: -1000,
        y: -213,
        z: 247,
    },
    // 9号线
    {
        id: '1681834436952068103',
        label: 'bz',
        x: 452,
        y: -907,
        z: -1000,
    },
    {
        id: '867124065395964',
        label: 'sq',
        x: 506,
        y: -897,
        z: -1000,
    },
    // 10号线
    {
        id: '867124065395923',
        label: 'sq',
        x: 1000,
        y: -879,
        z: -57,
    },
    {
        id: '35FFEA0B3356333527820143',
        label: 'qx',
        x: 1000,
        y: -894,
        z: 8,
    },
]

export const l2DeviceList = [
    {
        id: '79739C3621456A2F',
        label: 'bz',
        x: -1000,
        y: -807,
        z: 262,
    },
    {
        id: '56AAAE16E4F0D389',
        label: 'cq',
        x: -1000,
        y: -755,
        z: 197,
    },
    {
        id: '37FFD5055642393729702451',
        label: 'qx',
        x: -1000,
        y: -700,
        z: 130,
    },
    {
        id: '26004100090000483136544E',
        label: 'cq',
        x: -1000,
        y: -654,
        z: 67,
    },
    {
        id: '867124065396038',
        label: 'sq',
        x: -1000,
        y: -606,
        z: 12,
    },
]

export const l3DeviceList = [
    {
        id: '867124065395923',
        label: 'sq',
        x: -559,
        y: -176,
        z: 1000,
    },
    {
        id: '35FFEA0B3356333527820143',
        label: 'qx',
        x: -528,
        y: -158,
        z: 1000,
    },
]

export const l4DeviceList = [
    {
        id: '27004100180000384753524E',
        label: 'qx',
        x: -1000,
        y: -402,
        z: -454,
    },
    {
        id: '28001000090000483136544E',
        label: 'cq',
        x: -1000,
        y: -389,
        z: -485,
    },
    {
        id: '867124065481608',
        label: 'sq',
        x: -1000,
        y: -377,
        z: -520,
    },
    {
        id: '1574556931816431619',
        label: 'cq',
        x: -1000,
        y: -413,
        z: -377,
    },
    {
        id: '1681834436952068101',
        label: 'bz',
        x: -1000,
        y: -420,
        z: -342,
    },
]

export const l5DeviceList = []

export const l6DeviceList = [
    {
        id: '1681834436952068103',
        label: 'bz',
        x: 205,
        y: -1000,
        z: -566,
    },
    {
        id: '867124065395964',
        label: 'sq',
        x: 88,
        y: -1000,
        z: -517,
    },
]
export const l7DeviceList = []
export const l8DeviceList = []
export const l9DeviceList = []
export const l10DeviceList = [
    {
        id: '1574556931774488578',
        label: 'cq',
        x: 1000,
        y: -381,
        z: -719,
    },
    {
        id: '1681834436952068097',
        label: 'bz',
        x: 1000,
        y: -336,
        z: -648,
    },
    {
        id: '33004300050000483136544E',
        label: 'cq',
        x: 1000,
        y: -290,
        z: -587,
    },
    {
        id: '867124065381782',
        label: 'sq',
        x: 1000,
        y: -255,
        z: -527,
    },
]
export const l11DeviceList = [
    {
        id: '1574556931774488578',
        label: 'cq',
        x: 1000,
        y: -242,
        z: -191,
    },
    {
        id: '1681834436952068097',
        label: 'bz',
        x: 1000,
        y: -213,
        z: -179,
    },
    {
        id: '33004300050000483136544E',
        label: 'cq',
        x: 1000,
        y: -177,
        z: -169,
    },
    {
        id: '867124065381782',
        label: 'sq',
        x: 1000,
        y: -160,
        z: -173,
    },
    // 8号线
    {
        id: '867124065408536',
        label: 'sq',
        x: 1000,
        y: -94,
        z: 465,
    },
]
